import { bookServiceApi } from '@/services/api';

export interface Tip {
  tips_id: number;
  book_id: number;
  content: string;
  likes_count: number;
  shares_count: number;
  book_title: string;
  book_category?: string | null;
  content_type?: 'novel' | 'non_fiction' | string;
  book_cover_image_url: string | null;
  is_liked: boolean;
}

export interface TipsPagination {
  page: number;
  limit: number;
  total_count: number;
  total_pages: number;
}

export interface TipsFeedResponse {
  items: Tip[];
  pagination: TipsPagination;
}

export const getTipsFeed = async (page: number = 1, limit: number = 10): Promise<TipsFeedResponse> => {
  const response = await bookServiceApi.get<TipsFeedResponse>('/tips/feed', {
    page: String(page),
    limit: String(limit),
  });

  if (response.success && response.data) {
    return response.data;
  }

  throw new Error(response.error || 'Failed to fetch tips feed');
};

export const likeTip = async (tipId: number): Promise<{ liked: boolean }> => {
  const response = await bookServiceApi.post(`/tips/${tipId}/like`);
  if (!response.success) {
    throw new Error(response.error || 'Failed to like/unlike tip');
  }
  return response.data as { liked: boolean };
};

export const shareTip = async (tipId: number): Promise<void> => {
  const response = await bookServiceApi.post(`/tips/${tipId}/share`);
  if (!response.success) {
    throw new Error(response.error || 'Failed to share tip');
  }
};

export const viewTip = async (tipId: number): Promise<void> => {
  const response = await bookServiceApi.post(`/tips/${tipId}/view`);
  if (!response.success) {
    throw new Error(response.error || 'Failed to record tip view');
  }
};
